import React from "react";
import { Form, Message, Popup, Icon } from "semantic-ui-react";

function Expenses(props) {
  const { values, valid, enableFixedExpenses } = props;
  const rules = {
    expense_flat: "numeric",
    expense_venue_total: "numeric|expenses_venue",
    expense_venue_jackpot: "numeric",
    expense_cc_percent: "numeric",
    expense_cc_trans: "numeric"
  };
  props.setRules(rules);

  return (
    <Form size="large" error={valid.errorCount > 0}>
      <Message
        error
        content={Object.keys(valid.errors.all()).map((item, key) => {
          return (
            <span key={key}>
              {valid.errors.first(item)}
              <br />
            </span>
          );
        })}
      />
      <Form.Input
        label={() => (
          <Popup
            trigger={
              <label>
                <Icon name="help circle" color="blue" fitted /> Percentage Rate
                For All Sales
              </label>
            }
            content="Here you may enter a percentage rate to subtract from every raffle transaction (i.e. Bump license fee)."
            inverted
            wide
          />
        )}
        name="event.expense_flat"
        value={values.expense_flat}
        onChange={props.handleChange}
      />
      <Form.Field disabled={+enableFixedExpenses === 0}>
        <Popup
          trigger={
            <label>
              <Icon name="help circle" color="blue" fitted /> Fixed Expenses
            </label>
          }
          content="This option will allow you to gradually subtract a fixed expense amount from raffle ticket sales.
            Example: If you enter $1,500 to be subtracted until the jackpot reaches $10,000 then the system will calculate the amount to deduct from each sale until the jackpot reaches $10,000. In this example, 15% will be deducted from each transaction up to $10,000. After the jackpot reaches $10,000, the system will no longer deduct this expense."
          inverted
          wide
        />
      </Form.Field>
      <Form.Group inline>
        <Form.Input
          label="Until the jackpot reaches $"
          name="event.expense_venue_jackpot"
          value={values.expense_venue_jackpot}
          onChange={props.handleChange}
          disabled={+enableFixedExpenses === 0}
        />
        <Form.Input
          label="subtract $"
          name="event.expense_venue_total"
          value={values.expense_venue_total}
          onChange={props.handleChange}
          disabled={+enableFixedExpenses === 0}
        />
      </Form.Group>
      <Form.Group>
        <Form.Input
          label={() => (
            <Popup
              trigger={
                <label>
                  <Icon name="help circle" color="blue" fitted /> Credit Card Processing Percent
                </label>
              }
              content={`Percentage rate to subtract from credit card sales only. Note that if you have entered an amount for the "All Sales Percentage" setting above then both amounts will be subtracted from credit card sales.`}
              inverted
              wide
            />
          )}
          name="event.expense_cc_percent"
          value={values.expense_cc_percent}
          onChange={props.handleChange}
        />
        <Form.Input
          label={() => (
            <Popup
              trigger={
                <label>
                  <Icon name="help circle" color="blue" fitted /> Credit Card Per Transaction Fee
                </label>
              }
              content={`Flat fee to subtract from each credit card sale.`}
              inverted
              wide
            />
          )}
          name="event.expense_cc_trans"
          value={values.expense_cc_trans}
          onChange={props.handleChange}
        />
      </Form.Group>
      <Form.Group inline>
        <Form.Button type="button" size="large" onClick={() => props.handleStep("jackpot")}>
          Go Back{" "}
        </Form.Button>
        <Form.Button
          type="button"
          primary
          size="large"
          onClick={() => props.handleStep("verify")}
        >
          Save And Continue{" "}
        </Form.Button>
      </Form.Group>
    </Form>
  );
}

export default Expenses;
